import React from 'react'

import { useToast } from '@enuygun/design-system'
import Cookie from 'js-cookie'

import { useIsMobile } from 'hooks/useIsMobile'
import { useTranslation } from 'next-i18next'
import { useDeviceType } from 'hooks/useDeviceType'

import { resolveConsentProvider } from 'utils/consentProvider'
import { useAppState } from 'context/AppContext'
import { CookieAlertText } from './styled'

const CookieAlert = () => {
  const cookieAlert = useToast()
  const { t } = useTranslation()
  const { host, market } = useAppState()
  const isMobile = useIsMobile()
  const { isTablet } = useDeviceType()

  // OneTrust veya CookieYes yüklü host'larda bu basit bilgilendirme toast'u gösterilmez (utils/consentProvider)
  const consentProviderName = resolveConsentProvider(host)?.provider ?? null

  React.useEffect(() => {
    if (!consentProviderName && market) {
      const cookieStr = Cookie.get('cookieAlert')

      const parsedCookie = cookieStr ? JSON.parse(cookieStr) : null
      if (!parsedCookie && cookieAlert) {
        const cookieText = t('cookies.text', { host: host })

        cookieAlert?.toast !== undefined &&
          cookieAlert?.toast(
            {
              text: <CookieAlertText dangerouslySetInnerHTML={{ __html: cookieText }}></CookieAlertText>,
              show: true,
              autoClose: false,
              closeAriaLabel: t('cookies.close'),
            },
            isMobile ? 'bottom' : 'bottom-left'
          )
        Cookie.set('cookieAlert', 'true', { expires: 356 })
      }
    }
  }, [consentProviderName, cookieAlert, isMobile, isTablet, t, market, host])
  return null
}

export default CookieAlert
